/**
 * Format countries data for dropdown display
 * @param {Array} countries - The countries array from the API
 * @return {Array} Formatted countries with unique keys for dropdown
 */
const formatCountries = (countries) => {
  // Handle empty or invalid input
  if (!countries || !Array.isArray(countries) || countries.length === 0) {
    return []
  }

  // Create a map to track used keys and avoid duplicates
  const keyMap = new Map()

  return countries
    .map((country, index) => {
      // Ensure country has required fields
      if (!country || !country.printable_name) {
        console.warn('Invalid country object encountered:', country)
        return null // Will be filtered out
      }

      // Create a unique value from the country code or index if code is missing
      const countryValue = country.iso_3166_1_a2 || `country_${index}`

      // Generate a unique key to avoid React warnings
      let key = countryValue
      if (keyMap.has(key)) {
        const count = keyMap.get(key) + 1
        keyMap.set(key, count)
        key = `${key}_${count}`
      } else {
        keyMap.set(key, 1)
      }

      return {
        key, // Unique key for React
        label: country.printable_name, // Display name
        value: countryValue, // Value for form
      }
    })
    .filter(Boolean) // Remove any null entries
}

export default formatCountries
